import { render, staticRenderFns } from "./012_Touristen.vue?vue&type=template&id=3dea651b&scoped=true&"
import script from "./012_Touristen.vue?vue&type=script&lang=js&"
export * from "./012_Touristen.vue?vue&type=script&lang=js&"
import style0 from "./012_Touristen.vue?vue&type=style&index=0&id=3dea651b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea651b",
  null
  
)

export default component.exports